import React, { Component } from 'react'
import FixedView from '../components/FixedView'
import { checkTranslation, imageAddress, translate } from '../utils/useful'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import HttpServices from '../utils/Http.services'
import { widgetsList } from '../variables/widgetsList';
import ReactLoaderSpinner from 'react-loader-spinner';
import { FormBuilderObjects } from '../variables/formBuilderData';

class CardBuilderAddElement extends Component {

    state = {
        fixed: true,
        allApplets: [],
        currentApplet: {},
        fromApplet: true,
        selectedParent: {},
        options: [
            { label: 'Text', key: 'TextWidget', image: '/assets/icons/builder/text.svg', information: { style: { padding: '0px 7px 0px 7px' } } },
            { label: 'Image', key: 'ImageWidget', image: '/assets/icons/builder/image.svg', information: { placeholder: '/images/noimageavailable.png', style: { width: 100, widthUnit: '%', borderRadius: 6 } } },
            { label: 'Button', key: 'ButtonWidget', image: '/assets/icons/builder/button.svg', information: { label: '{{lang}}Learn More' } },
            // {label:'Devider',key:'devider',image:'/assets/icons/useful/gallery.png'},
            // { label: 'Spacer', key: 'CardSpacer', image: '/assets/icons/useful/stack1.png', information: { height: 'auto' } },
            { label: 'Video', key: 'VideoWidget', image: '/assets/icons/builder/video.svg', information: { style: { width: 100, widthUnit: '%', borderRadius: 6 } } },
            { label: 'audio', key: 'AudioWidget', image: '/assets/icons/builder/audio.svg' },
            { label: 'File', key: 'FileWidget', image: '/assets/icons/builder/file.svg' },

        ],
        isLoadingData: false
    }

    componentDidMount() {
        // this.fetcAllApplets()

    }

    openFirstView = () => {
        let view = this.state.fixed
        this.setState({ fixed: !view }, () => {
            if (this.state.fixed == true) {
                this.firstView.hideView()
            } else {
                this.firstView.showView()
            }
        })
    }




    onDragStart = (e, rowId, type) => {
        if (e.dataTransfer.setData) {
            e.dataTransfer.setData("type", type);
            e.dataTransfer.setData("dropType", "NEW");
            if (this.state.currentApplet) {
                e.dataTransfer.setData("currentApplet", this.state.currentApplet._id);
            }
        } else {
            e.dataTransfer.rowId = rowId;
            e.dataTransfer.type = type;
            e.dataTransfer.dropType = "NEW";
        }
        this.props.onDragStartAction(e)
        setTimeout(() => {
            this.firstView.hideView()
        }, 100);
    };


    // fetcAllApplets = () => {
    //     let username
    //     let allApplets = this.state.allApplets
    //     if (this.props?.user?.info?.username) {
    //         username = this.props.user?.info?.username
    //     }
    //     this.setState({ isLoadingData: true })
    //     HttpServices.request('getHubByUsername', { username: username }, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingPost: false })
    //         if (fetchError) {
    //             // this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
    //             return
    //         }
    //         // { console.log('usernameeeeeeeeeeees', fetchResult) }
    //         fetchResult.applets.forEach(applet => {
    //             if (applet.applet.features[0]) {
    //                 allApplets.push(applet)
    //             }
    //         });
    //         // console.log('this.props.applet', this.props.applet)
    //         this.setState({ allApplets }, () => {
    //             if (this.props.applet) {
    //                 fetchResult.applets.forEach(applet => {
    //                     // console.log('appppppppppppplet issssss', applet)
    //                     // console.log('apppppppppppppppppppplet1', applet.applet._id)
    //                     // console.log('apppppppppppppppppppplet2', this.props.applet._id)
    //                     if (applet.applet._id == this.props.applet._id) {
    //                         // console.log('apppppppppppppppppppplet', applet)
    //                         let selectedParent = this.state.selectedParent
    //                         let slug = String(applet.applet.slug).charAt(0).toLocaleUpperCase() + String(applet.applet.slug).slice(1)
    //                         selectedParent.type = applet.features[0] ?? slug
    //                         this.setState({ currentApplet: applet.applet, fromApplet: true, selectedParent }, () => {
    //                             // console.log('xxxxxxxxxxxxxxxxxxxxxxxx', this.state.currentApplet, selectedParent)
    //                         })
    //                     }
    //                 });
    //             }
    //             else {
    //                 this.setApplet(allApplets[0].applet)
    //             }
    //             this.setState({ isLoadingData: false })
    //         })
    //         // this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccesfully', description: '{{lang}}info.postSuccesfullyDesc' })
    //     })
    // }

    addElement = (item) => {
        this.props.addElement(item)
        this.firstView.hideView()
    }

    render() {
        const { hideHandlers } = this.props;
        return (
            <div className='w-100 h-100' ref={el => this.firstCurrentNode = el}>
                <button className={" px-3 py-2 flexc br-20 " + (this.state.fixed == true ? " add-element " : " add-element-selected ")} onClick={() => this.openFirstView()} style={{ background: this.props.colors?.background, color: this.props.colors?.textColor }}>
                    <img className={'' + (!this.props.colors?.iconInvert ? 'invert' : '')} width={14} src='/assets/icons/pagebuilder/plus-black.svg' />
                    <p className='font-size-12  weight-500'>{translate('Add Element')}</p>
                </button>
                <div className='w-100 h-100'>
                    <FixedView onHide={() => this.setState({ fixed: true })} ref={el => this.firstView = el} nodeRef={this.firstCurrentNode} showFocus={false} fixed={this.state.fixed} topOffset={5} bottomOffset={28} xOffset={-10} zIndex={20} width={240} >
                        <div className=" px-1 py-1  d-flex flex-column w-100 " style={{ boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 10 }}>
                            {/* <div className='br-10 bg-white shadow-3' style={{ height: "300px" }}> */}
                            {this.state.isLoadingData ? (
                                <div className='flexcc w-100 h-100' style={{}}>
                                    <ReactLoaderSpinner type={"Oval"} color={this.props.colors?.primaryColor ?? '#eee'} height={40} width={40} />
                                </div>
                            ) : (
                                <div className='sc-gray2 pb-1 px-1  w-100' style={{ maxHeight: 250, overflow: 'auto', }}>
                                    {/* <div className={this.state.fromApplet ? 'w-100 h-100' : 'flexcb w-100 h-100'} style={{}}> */}
                                    {/* {!this.state.fromApplet && ( */}
                                    <div className='h-100' style={{}} >
                                        <div className='h-100' style={{}} >
                                            <div className='position-sticky top-0 py-1' style={{ backgroundColor: "#fff", borderBottom: "0px solid #eee", zIndex: 10 }}>
                                                <div className='w-100 flexcc ' style={{ borderBottom: "0px solid #eee", height: '35px', backgroundColor: "#fff", }}>
                                                    <input placeholder={translate('Search')} className='px-2 br-5 w-100 h-100 font-size-14' style={{ backgroundColor: '#f6f6f6', border: '0px solid #F2F2F7' }} />
                                                </div>
                                            </div>

                                            {this.state.isLoadingData ? (
                                                <div className='flexcc w-100 pt-5'>
                                                    <ReactLoaderSpinner type={"Oval"} color={this.props.colors?.primaryColor ?? '#eee'} height={40} width={40} />
                                                </div>
                                            ) : (

                                                <>
                                                    {this.state.options.map((item, index) => {
                                                        return (
                                                            <div className="flexcb w-100 hover-gray p-2 br-5" key={item._id}>
                                                                <button className=" flexcb w-100 text-smaller text-start px-1" style={{ cursor: 'pointer', }} onDragStart={(e) => this.onDragStart(e, index, item.key)} onDragEnd={hideHandlers} onClick={() => { this.addElement(item) }} draggable={true}>
                                                                    <div className='flexc'>
                                                                        <img draggable={false} src={item.image} className='mrd-3' height={20} />
                                                                        <p draggable={false} className=" font-size-13 mld-2 main-c3 text-start">{translate(item.label)}</p>
                                                                    </div>
                                                                    <img draggable={false} src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 ' />

                                                                </button>
                                                                {/* <img src='/assets/icons/angle-right.svg' width={18} className='flexcc opacity-2' /> */}
                                                            </div>
                                                        );
                                                    })}
                                                    <p className='text-smaller mt-2 px-2 text-bold '>{translate("Collection Fields")}</p>
                                                    <div className='mt-2 pb-3' style={{ borderTop: '1px solid #eee' }}>
                                                        {this.props.fields?.map((item, index) => {
                                                            return (
                                                                <div className="pld-2 pt-2 pb-1 w-100 br-6  flexcb " key={item._id}>
                                                                    <button className=" flexcb w-100 text-smaller text-start px-1" style={{ cursor: 'pointer', }} onClick={() => { this.addElement(item.applet) }}>
                                                                        <div className='flexc'>
                                                                            <img draggable={false} src={FormBuilderObjects[item.type]?.icon} className='br-20 mrd-3' height={20} style={{ filter: 'grayscale(0%)' }} />
                                                                            <p draggable={false} className=" text-semibold text-small">{translate(item.information?.label)}</p>
                                                                        </div>

                                                                        <img src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 ' />

                                                                    </button>
                                                                    {/* <img src='/assets/icons/angle-right.svg' width={18} className='flexcc opacity-2' /> */}
                                                                </div>
                                                            );
                                                        })}

                                                    </div>


                                                </>
                                            )}
                                        </div>
                                    </div>


                                    {/* )} */}
                                    {/* <div className='px-1 h-100' style={{ width: this.state.fromApplet ? "250px" : "175px", }} >
                                        <div className='px-1 overflow-auto sc-gray2 h-100' style={{}} >
                                            <div className='position-sticky top-0 pb-1 pt-2' style={{ backgroundColor: "#fff", borderBottom: "1px solid #eee", zIndex: 10 }}>
                                                <div className='w-100  mb-1 flexc ' style={{ borderBottom: "0px solid #eee", height: '30px', cursor: 'auto' }}>
                                                    <p className='px-2 font-size-13 main-c2'>Drag an element</p>
                                                </div>
                                            </div>

                                            {(!this.state.currentApplet._id) ? (
                                                !this.state.fromApplet &&
                                                <div className='flexcc w-100 pt-5'>
                                                    <ReactLoaderSpinner type={"Oval"} color={this.props.colors?.primaryColor ?? '#eee'} height={40} width={40} />
                                                </div>
                                            ) : (
                                                Object.values(widgetsList).map((formItem, index) => {
                                                    if (formItem.parents && this.state.selectedParent?.type && (formItem.parents.includes(this.state.selectedParent.type) || formItem.parents.includes('all'))) {
                                                        return (
                                                            <div className="py-2 w-100 flexcb" style={{ cursor: 'move' }} key={formItem.type} onDragStart={(e) => this.onDragStart(e, index, formItem.key)} onDragEnd={hideHandlers} draggable={true}>
                                                                <img src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 prd-3' />
                                                                <div key={index} className=" flexc w-100 text-smaller " style={{}}>
                                                                    <img draggable={false} src={formItem.icon} height={22} />
                                                                    <p draggable={false} className="mld-3">{checkTranslation(formItem.label)}</p>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                })
                                            )}
                                        </div>
                                    </div> */}
                                </div>
                            )}
                        </div>
                    </FixedView>
                </div >
            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CardBuilderAddElement);